module.exports = __webpack_public_path__ + "static/media/proj12_img2.72cb591b.jpg";